import updateConsent from './update_consent';
import { boundSetUserPurposes } from '../../redux/actions/consent';

const setPurposesNegative = function() {
    boundSetUserPurposes([]);
    updateConsent();
};

export default setPurposesNegative;